import "./Icon.scss"
import React, { PropTypes } from "react"
import classnames from "classnames"
import * as Icons from "../assets/Icons"
import * as UiIcons from "../assets/UiIcons"
import * as FillIcons from "../assets/FillIcons"

function getIcon(name, type) {
  switch (type) {
    case "legacy":
      return Icons[name]
    case "fill":
      return FillIcons[name]
    case "ui":
    default:
      return UiIcons[name]
  }
}

const Icon = ({ name, type, size, spin, color, className }) => {
  const Icon = getIcon(name, type)
  if (Icon) {
    const style = { width: size, height: size }
    return (
      <div
        className={classnames(
          "Icon",
          spin && "Icon-spin",
          className,
          `Icon-${name}`
        )}
        style={style}>
        <Icon style={style} color={color} />
      </div>
    )
  } else {
    return null
  }
}

Icon.displayName = "Icon"

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["ui", "fill", "legacy"]).isRequired,
}

Icon.defaultProps = {
  size: 16,
  type: "ui",
  color: "#B3B3BF",
}

export default Icon



// WEBPACK FOOTER //
// ./src/lib/Icon.js